/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Cockpit_Stat_Approval_ValueInputs */

const tr_landing_cockpit_stat_approval_value = /** @type {(inputs: Landing_Cockpit_Stat_Approval_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8sn`)
};

const en_landing_cockpit_stat_approval_value = /** @type {(inputs: Landing_Cockpit_Stat_Approval_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8s`)
};

const de_landing_cockpit_stat_approval_value = /** @type {(inputs: Landing_Cockpit_Stat_Approval_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 Sek.`)
};

const ru_landing_cockpit_stat_approval_value = /** @type {(inputs: Landing_Cockpit_Stat_Approval_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`8 с`)
};

/**
* | output |
* | --- |
* | "8s" |
*
* @param {Landing_Cockpit_Stat_Approval_ValueInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_cockpit_stat_approval_value = /** @type {((inputs?: Landing_Cockpit_Stat_Approval_ValueInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Cockpit_Stat_Approval_ValueInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_cockpit_stat_approval_value(inputs)
	if (locale === "de") return de_landing_cockpit_stat_approval_value(inputs)
	if (locale === "ru") return ru_landing_cockpit_stat_approval_value(inputs)
	return tr_landing_cockpit_stat_approval_value(inputs)
});